'use strict';

/**
 * @ngdoc service
 * @name courseApp.ActCourseService
 * @description
 * # ActCourseService
 * Service in the courseApp.
 */
angular.module('courseApp')
    .service('ActCourseService', function () {
        var vm = this;
        vm.actCourse = undefined;

        return {
            setActCourse: function (course) {
                vm.setActCourse = course;
            },
            getActCourse: function () {
                return vm.setActCourse;
            }
        };
    });
